<template>
  <el-container style="max-width: 1920px;margin: auto;min-width: 1200px">
    <el-header style="background: #35383b">
      <div style="float: left;display: flex; margin-top: 15px">
        <img class="img_icon" src="@/assets/icon.png">
        <span style="line-height: 30px;color: white">黑点科技</span>
      </div>
    </el-header>
    <el-main style="height: 800px">
      <router-view/>
    </el-main>


    <el-footer style="background: #35383b;color: white;height: 170px;">
      <div>
        <h4>联系我们</h4>
      </div>
      <div>
        <h5>黑点（山东）电子科技有限公司</h5>

      </div>
      <div>
        <h5>地址:山东省滨州市博兴县兴福镇汾王村村前路150号202  </h5><br />
        <h5>违法信息举报 违法和不良信息举报电话:0543-2828086 举报邮箱:heidiankeji@outlook.com</h5>
      </div>

      <div class="a_icpmsg">
        <a href="http://beian.miit.gov.cn" target="_blank">鲁ICP备19024605号-2</a>
      </div>
    </el-footer>


  </el-container>
</template>

<script>
    export default {
        name: "home",
        data() {
            return {
                activeIndex: '1'
            };
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            }
        }
    }
</script>

<style scoped lang="scss">
  .img_icon {
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;

  }

  h4 {
    line-height: 50px;
  }

  h5 {
    display: inline-block;
    margin: 0;
    line-height: 30px;
  }

  .a_icpmsg {
    text-align: center;
    margin: auto;
    margin-top: 8px;

    a {
      font-size: 15px;
      text-decoration: underline;
      color: #fff;
    }
  }

  .el-footer {

  }

</style>



// WEBPACK FOOTER //
// src/view/home.vue